/**
 * SAFE_LAND_DISABLED (2026-05)
 * Safe-Land Zones feature is hidden from UI per PM request.
 * Backend endpoints, redux slices, entities, pages, forms and the ArcSafeLand
 * marker are intentionally kept intact so the feature can be brought back
 * with a quick uncomment pass.
 *
 * Touched files (run `rg SAFE_LAND_DISABLED` to find every block):
 *  - src/features/zones/feature.tsx                                            (this file)
 *  - src/features/zones/pages/zones-page/sidebar.tsx
 *  - src/core/controllers/map/components/toolbar/components/layers/index.tsx
 *
 * To restore: search for `SAFE_LAND_DISABLED`, uncomment every marked block,
 * then delete the marker comments.
 */
import React from "react";
import { Route, Routes } from "react-router-dom";
import { ZonesPage } from "./pages/zones-page/sidebar";
import { ArcBaseContent, ArcBaseSidebar } from "@src/core/components";
import { ArcGoogleMap } from "@src/core/controllers";
import ZonesMap from "./pages/zones-page/map";
import { ArcStack } from "@src/core/ui";
import { CreateZonePage } from "./pages/create-zone";
import { EditZonePage } from "./pages/edit-zone";
// SAFE_LAND_DISABLED (2026-05): To restore: uncomment imports and the matching <Route> elements below.
// import { EditSafeLandZonePage } from "./pages/edit-safe-land-zone";
// import { useGetSafeLandZonesQuery } from "@src/features/zones/redux";
// import { VARIANT_SAFE_LAND } from "./pages/zones-page/types";
// import { safeLandZoneToZoneEntity } from "./utils";
import { useGetZonesQuery } from "@src/core/features";

const ZonesMapWrapper: React.FC = () => {
  const { data: zones } = useGetZonesQuery();
  // SAFE_LAND_DISABLED (2026-05): To restore: uncomment block + return zonesWithSafeLand instead of zones.
  // const { data: safeLandZones } = useGetSafeLandZonesQuery();
  // const safeLandAsZones = (safeLandZones ?? []).map(safeLandZoneToZoneEntity);
  // const zonesWithSafeLand = [...(zones ?? []), ...safeLandAsZones];
  return <ZonesMap zones={zones ?? []} />;
};

const ZonesFeature: React.FC = () => {
  return (
    <ArcStack direction='row'>
      <ArcBaseSidebar>
        <Routes>
          <Route path="" element={<ZonesPage />} />
          <Route path="create" element={<CreateZonePage />} />
          {/* SAFE_LAND_DISABLED (2026-05): To restore: uncomment the two routes below. */}
          {/* <Route path="create-safe-land" element={<CreateZonePage variant={VARIANT_SAFE_LAND} />} /> */}
          <Route path="edit/:id" element={<EditZonePage />} />
          {/* <Route path="edit-safe-land/:id" element={<EditSafeLandZonePage />} /> */}
        </Routes>
      </ArcBaseSidebar>
      <ArcBaseContent>
        <ArcGoogleMap>
          <ZonesMapWrapper />
        </ArcGoogleMap>
      </ArcBaseContent>
    </ArcStack>
  );
};

export default ZonesFeature;
